
/* TIC® Store — Elite Interactions */
(function() {
  'use strict';

  /* 1. STAT COUNTER ANIMATION — Numbers count up when scrolled into view */
  function animateCounters() {
    const items = document.querySelectorAll('.color-accent-1 .multicolumn-list__item-title');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.dataset.counted) {
          entry.target.dataset.counted = 'true';
          const text = entry.target.textContent.trim();
          const num = parseFloat(text.replace(/[^0-9.]/g, ''));
          const suffix = text.replace(/[0-9.]/g, '').trim();
          if (!isNaN(num) && num > 0) {
            const duration = 1800;
            const start = performance.now();
            const startVal = 0;
            function update(now) {
              const elapsed = now - start;
              const progress = Math.min(elapsed / duration, 1);
              // Ease out cubic
              const eased = 1 - Math.pow(1 - progress, 3);
              const current = startVal + (num - startVal) * eased;
              let display;
              if (num >= 1000) {
                display = Math.round(current / 100) / 10 + 'K';
              } else if (num % 1 !== 0) {
                display = current.toFixed(1);
              } else {
                display = Math.round(current).toString();
              }
              entry.target.textContent = display + (suffix.includes('+') ? '+' : suffix.includes('%') ? '%' : suffix.includes('K') ? '' : suffix);
              if (progress < 1) requestAnimationFrame(update);
              else entry.target.textContent = text;
            }
            requestAnimationFrame(update);
          }
        }
      });
    }, { threshold: 0.3 });
    items.forEach(el => observer.observe(el));
  }

  /* 2. SCROLL REVEAL — Sections fade up as they enter viewport */
  function initScrollReveal() {
    const style = document.createElement('style');
    style.textContent = `
      .reveal-ready { opacity: 0; transform: translateY(28px); transition: opacity 0.7s ease, transform 0.7s ease; }
      .reveal-ready.revealed { opacity: 1; transform: translateY(0); }
    `;
    document.head.appendChild(style);

    const targets = document.querySelectorAll(
      '.featured-collection, .image-with-text, .multicolumn:not(.color-accent-1)'
    );
    targets.forEach(el => el.classList.add('reveal-ready'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }

  /* 3. PRODUCT CARD STAGGER — Cards appear one by one with delay */
  function staggerCards() {
    const style = document.createElement('style');
    style.textContent = `
      .card-wrapper { opacity: 0; transform: translateY(24px); transition: opacity 0.5s ease, transform 0.5s ease; }
      .card-wrapper.card-visible { opacity: 1; transform: translateY(0); }
    `;
    document.head.appendChild(style);

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const siblings = Array.from(entry.target.closest('.grid, ul, [class*="product-grid"]')?.children || [entry.target]);
          const idx = siblings.indexOf(entry.target);
          setTimeout(() => entry.target.classList.add('card-visible'), idx * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.card-wrapper').forEach(el => observer.observe(el));
  }

  /* 4. CURSOR GLOW — Subtle blue glow that follows cursor on desktop */
  function initCursorGlow() {
    if (window.matchMedia('(hover: none)').matches) return;
    const glow = document.createElement('div');
    glow.style.cssText = `
      position: fixed; pointer-events: none; z-index: 9999;
      width: 300px; height: 300px; border-radius: 50%;
      background: radial-gradient(circle, rgba(59,130,246,0.08) 0%, transparent 65%);
      transform: translate(-50%, -50%);
      transition: opacity 0.3s ease;
      mix-blend-mode: screen;
    `;
    document.body.appendChild(glow);
    let mx = -999, my = -999;
    document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; glow.style.left = mx + 'px'; glow.style.top = my + 'px'; });
    document.addEventListener('mouseleave', () => { glow.style.opacity = '0'; });
    document.addEventListener('mouseenter', () => { glow.style.opacity = '1'; });
  }

  /* 5. HEADER SCROLL COMPRESSION — Header shrinks slightly when scrolled */
  function initHeaderScroll() {
    const header = document.querySelector('.header-wrapper, .shopify-section-header');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y > 60) {
        header.style.transition = 'all 0.3s ease';
        header.style.boxShadow = '0 4px 40px rgba(2,23,54,0.8)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = y;
    }, { passive: true });
  }

  /* 6. ADD TO CART RIPPLE — Blue ripple effect on cart button tap */
  function initCartRipple() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('.quick-add__submit, .product-form .button');
      if (!btn) return;
      const ripple = document.createElement('span');
      const rect = btn.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      ripple.style.cssText = `
        position: absolute;
        border-radius: 50%;
        background: rgba(255,255,255,0.3);
        width: ${size}px; height: ${size}px;
        left: ${e.clientX - rect.left - size/2}px;
        top: ${e.clientY - rect.top - size/2}px;
        transform: scale(0);
        animation: ripple 0.6s ease-out forwards;
        pointer-events: none;
      `;
      if (!document.getElementById('ripple-style')) {
        const s = document.createElement('style');
        s.id = 'ripple-style';
        s.textContent = '@keyframes ripple { to { transform: scale(2.5); opacity: 0; } }';
        document.head.appendChild(s);
      }
      btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(ripple);
      setTimeout(() => ripple.remove(), 700);
    });
  }

  /* INIT */
  function init() {
    animateCounters();
    initScrollReveal();
    staggerCards();
    initCursorGlow();
    initHeaderScroll();
    initCartRipple();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
